import React from 'react'
import { ChevronLeft } from 'react-feather'
import { Container } from './container'

const DashboardHeader = ({children, handleBack, addButton}) => {
  return (
    <div className="w-full border-t border-b py-4 mt-2" style={{borderColor: '#ddd'}}>
      <Container>
        <div className="relative">
          <div
            style={{top: '50%', transform: 'translateY(-50%)'}}
            className="absolute left-0"
            onClick={handleBack}
          >
            <ChevronLeft />
          </div>
          <h1 className="text-lg font-bold font-primary text-center">
            {children}
          </h1>
          {
            addButton &&
            <div
              style={{top: '50%', transform: 'translateY(-50%)'}}
              className="absolute right-0"
            >
              {addButton}
            </div>
          }
        </div>
      </Container>
    </div>
  )
}

export { DashboardHeader }